module.exports = __webpack_public_path__ + "static/media/sub-card-label-6-over.e121796f.svg";